
import Answer from './answer.vue'
import AiSugggestion from '../ai-suggestion.vue'
import AiEditor from '../ai-editor.vue'
import Cards, {SaveDoc} from 'components/cards-v2'
import Widgets from 'components/widgets'
import {computed} from 'vue'
import AiFile from '../ai-file'
import {SourcesModal, SourcesSection, SourceType} from 'components/sources-v2'
import Research from './research'
// import AiLogo from '../ai-logo.vue'

export default {
  components: {
    SaveDoc,
    Widgets,
    Answer,
    AiEditor,
    Cards,
    AiSugggestion,
    AiFile,
    // AnswerTabs,
    SourcesSection,
    SourcesModal,
    SourceType,
    Research
  },
  provide() {
    return {
      di_sources: computed(() => this.sources),
      di_widgets: computed(() => this.widgets),
      di_last_answer: computed(() => this.lastAnswer)
    }
  },
  props: {
    chatId: {type: String, required: true},
    item: {type: Object, required: true},
    generating: {type: Boolean, default: false},
    lastAnswer: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
    restricted: {type: Boolean, default: false},
  },
  emits: ['ask-ai', 'text-added', 'like', 'dislike', 'refrag', 'save', 'follow-person', 'follow-company'],
  data() {
    return {
      typing: false,
      render_widgets: false,
    }
  },
  computed: {
    internal(){
      return this.item.data?.internal
    },
    cards() {
      return this.item.data?.cards
    },
    suggestions() {
      return this.item.data?.suggestions
    },
    is_editor() {
      return !this.readonly && this.lastAnswer && this.item.data?.editable
    },
    inline_btns() {
      return this.item.data?.inline_btns
    },
    file_download(){
      return this.item.data?.file_download
    },
    intermediate(){
      return !!this.item.intermediate
    },
    self_loading(){
      return this.intermediate || this.typing
    },
    sources() {
      const items = this.item.data?.sources || []
      if (!this.self_loading && items.length === 0)
        items.push({
          type: 'genrate',
          name: `${this.$global.brand_name} Agent`,
          logo: this.$global.max_style ? '/assets/max-icon.svg' : '/assets/genrate-icon.svg',
          summary: 'Formulated via the agent\'s internal reasoning engine and pre-existing knowledge base.',
        })
      return items
    },
    text() {
      return this.item.data?.text || ''
    },
    widgets() {
      return this.item.data?.widgets || []
    },
    liked(){
      return this.item.liked > 0
    },
    disliked(){
      return this.item.liked < 0
    },
    //

    ///
    reasoning(){
      const reasoning = this.item.data?.reasoning
      if (reasoning?.length > 0) {
        return reasoning
      }

      const status = this.item.data?.status
      if (status) {
        return [status]
      }

      return undefined
    },
    completed() {
      // reasoning for previous answers is always completed
      if (!this.lastAnswer) return true

      // reasoning while we're still generating is not completed
      if (this.self_loading) return false

      // assistant questions are answered through chat input v2
      if (this.ai_question) return false

      return true
    },

    ai_question() {
      return this.item.data?.question
    },
  },
  created() {
    this.$listen('inline-button', this.onInlineButton)
  },
  methods: {
    async getRenderedWidgets() {
      if (!this.widgets?.length) return []

      this.render_widgets = true
      await this.$nextTick()

      try {
        return await this.$refs.widgets_export?.getImages() || []
      }
      finally {
        this.render_widgets = false
      }
    },
    async copyAnswer(){
      await this.$refs.answer.copyText()
    },
    onTextAdded(full) {
      this.typing = !full
      this.$nextTick(() => this.$emit('text-added', full))
    },
    onInlineButton(idx) {
      this.$emit('ask-ai', this.inline_btns[idx])
    },
    openSources() {
      this.$refs.sources.open()
    },
    getAnswerTabs() {
      return this.$refs['answer-tabs']
    },
  }
}
